/* eslint-disable no-underscore-dangle */import { createReducer, createAction } from 'redux-act';
import { createSelector, createStructuredSelector } from 'reselect';
import { selectIsAuthenticatedUser, selectUserCountryCode, selectUserCurrency, saveUserCountryCode, saveAuthenticatedUserInfos, saveCurrencies, saveCurrentCurrency } from '@gandi/authentication';
import { fetchCountry, selectCurrencies } from '@gandi/redux-places';
import { fetchCurrentSharing, selectCurrent, selectCurrentId } from '@gandi/redux-sharing';
import { fetchCurrencies, selectDefaultCurrency } from './currencies';
import { fetchInfos, selectGrid } from './infos';
import { selectCurrency } from './prepaid';
import { selectRaw as selectRawState } from './utils';
export const selectRaw = createSelector([selectRawState], raw => raw.pricing);
export const selectPricingIsLoaded = createSelector([selectRaw], raw => raw.isLoaded);
export const selectPricingIsFailure = createSelector([selectRaw], raw => raw.isFailure);
export const selectPricingIsToRefetch = createSelector([selectRaw], raw => raw.isToRefetch);
export const selectPricingIsFetching = createSelector([selectRaw], raw => raw.isFetching);
const selectDefaultBUCurrencyProps = createStructuredSelector({
  sharingId: selectCurrentId,
  country: selectUserCountryCode
});
const selectPrepaidCurrency_ = state => selectCurrency(state, {
  sharingId: selectCurrentId(state)
});
const selectDefaultBUCurrency_ = state =>
// $FlowFixMe[incompatible-call] country ccan be undefined in selectDefaultCurrency, but is string in selectDefaultBUCurrencyProps.
selectDefaultCurrency(state, selectDefaultBUCurrencyProps(state));
const selectGuessedCurrency_ = state => {
  const maybeCurrency = selectUserCurrency(state);
  // eslint-disable-next-line no-extra-boolean-cast
  return Boolean(maybeCurrency) ?
  // $FlowFixMe[incompatible-type]
  maybeCurrency : undefined;
};
const selectGrid_ = state => selectGrid(state, {
  sharingId: selectCurrentId(state)
});
const selectCurrency_ = createSelector([selectPrepaidCurrency_, selectDefaultBUCurrency_, selectGuessedCurrency_], (prepaidCurrency, defaultBUCurrency, guessedCurrency) => prepaidCurrency || defaultBUCurrency || guessedCurrency || 'USD');
export const selectPricingInfos = createStructuredSelector({
  currency: selectCurrency_,
  grid: selectGrid_,
  country: selectUserCountryCode,
  sharingId: selectCurrentId
});

// $FlowFixMe[unclear-type]
export const setPricingIsLoaded = createAction('[redux-billing][pricing] Set `isLoaded`');
// $FlowFixMe[unclear-type]
export const setPricingIsFailure = createAction('[redux-billing][pricing] Set `isFailure`');
// $FlowFixMe[unclear-type]
export const setPricingIsFetching = createAction('[redux-billing][pricing] Set `isFetching`');
// $FlowFixMe[unclear-type]
export const setPricingIsToRefetch = createAction('[redux-billing][pricing] Set `isToRefetch`');
const fetchCurrenciesByCountryCode = country => dispatch => dispatch(fetchCountry(country)).then(response => {
  dispatch(saveCurrencies(response.data.currencies));
  dispatch(saveCurrentCurrency(response.data.currencies[0]));
});
export const preFetchPricingInfos = currencyOverride => async (dispatch, getState) => {
  dispatch(setPricingIsFetching());
  try {
    const isLoggedIn = selectIsAuthenticatedUser(getState());
    const countryCode = selectUserCountryCode(getState());
    const sharingId = selectCurrentId(getState());
    if (!isLoggedIn || !sharingId) {
      await dispatch(fetchCurrenciesByCountryCode(countryCode));
      const currencies = selectCurrencies(getState(), countryCode);
      if (currencies.includes(currencyOverride)) {
        dispatch(saveCurrentCurrency(currencyOverride));
      }
      dispatch(setPricingIsLoaded());
      return;
    }
    let org = selectCurrent(getState());
    if (!org) {
      await dispatch(fetchCurrentSharing());
      org = selectCurrent(getState());
    }
    const country = org.country || countryCode;
    await dispatch(fetchCurrencies({
      country
    }));
    if (country !== countryCode) {
      dispatch(saveUserCountryCode(country));
      await dispatch(fetchCurrenciesByCountryCode(country));
    }
    const bu = org.bu_id;
    let prepaidCurrency = selectCurrency(getState(), {
      sharingId
    });
    if (prepaidCurrency) {
      dispatch(setPricingIsLoaded());
      return;
    }
    await dispatch(fetchInfos({
      sharingId
    }));
    prepaidCurrency = selectCurrency(getState(), {
      sharingId
    });
    if (prepaidCurrency) {
      dispatch(setPricingIsLoaded());
      return;
    }
    if (bu) {
      dispatch(saveAuthenticatedUserInfos({
        bu_id: bu
      }));
      await dispatch(fetchCurrencies({
        country
      }));
    }
    await dispatch(fetchCurrenciesByCountryCode(country));
    const currencies = selectCurrencies(getState(), countryCode);
    if (currencies.includes(currencyOverride)) {
      dispatch(saveCurrentCurrency(currencyOverride));
    }
    dispatch(setPricingIsLoaded());
  } catch (err) {
    dispatch(setPricingIsFailure());
    throw err;
  }
};
export const initialState = {
  isLoaded: false,
  isFetching: false,
  isFailure: false,
  isToRefetch: false
};
export const handleStateChange = flag => state => {
  const {
    isLoaded,
    isFetching,
    isFailure,
    isToRefetch
  } = state;
  if (flag in state) {
    if (flag === 'isFailure' && (isLoaded || isFetching)) {
      return {
        ...state,
        isFailure: true,
        isLoaded: false,
        isFetching: false
      };
    }
    if (flag === 'isLoaded' && (isFailure || isFetching || isToRefetch)) {
      return {
        isFailure: false,
        isLoaded: true,
        isFetching: false,
        isToRefetch: false
      };
    }

    // Update `isFetching` or `isToReFetch` to `true` if needed.
    // $FlowFixMe[invalid-computed-prop]
    if (!state[flag]) {
      return {
        ...state,
        [flag]: true
      };
    }
  }
  return state;
};
const reducer = createReducer({
  [setPricingIsLoaded]: handleStateChange('isLoaded'),
  [setPricingIsFetching]: handleStateChange('isFetching'),
  [setPricingIsToRefetch]: handleStateChange('isToRefetch'),
  [setPricingIsFailure]: handleStateChange('isFailure')
}, initialState);
export default reducer;